// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__HEdN8","footer":"ModalInfo_footer__2Uvf7"};